import script from "./MailSide.vue?vue&type=script&setup=true&lang=js"
export * from "./MailSide.vue?vue&type=script&setup=true&lang=js"

import "./MailSide.vue?vue&type=style&index=0&id=2130a5c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2130a5c3"]])

export default __exports__